import styled, { css } from 'styled-components';
import { BadgeOverlay } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import { Link } from 'react-router-dom';
import CustomerOpportunitiesBadge from 'components/CustomerOpportunitiesBadge';
import UserAvatar from 'components/UserAvatar';
import { ChannelType } from 'components/ChannelPicker/types';
import { GREY_500, PURPLE_100, GREY_100 } from '../../../../constants';

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid ${(props) => props.theme.rainbow.palette.border.divider};
    background-color: ${(props) => props.theme.rainbow.palette.background.white};
    min-height: 80px;
`;

export const CustomerInfoContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;

export const CustomerName = styled.button`
    text-align: left;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    &:hover {
        text-decoration: underline;
    }
`;

export const QuickActions = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: ${GREY_500};
    padding: 12px;
    border-radius: 100%;
    background: transparent;

    &:hover,
    &:focus,
    &:active {
        text-decoration: underline;
        color: rgb(103, 92, 216);
        background: ${PURPLE_100};
    }
`;

export const StyledBadgeOverlay = styled(BadgeOverlay)`
    & > span {
        width: 0.625rem;
        height: 0.625rem;
        box-sizing: border-box;
        border: 2px solid ${GREY_100};
        right: 0.325rem;
        border-radius: 100%;
    }
`;

export const StyledUserAvatar = styled(UserAvatar)<{ channel?: ChannelType }>`
    border: 4px solid #7367F0;
    svg {
        width: 2.5rem;
        height: 2.5rem;
    }

    ${(props) => props.channel === 'facebook' && css`
        border-color: #1877F2;
    `};
    
    ${(props) => props.channel === 'instagram' && css`
        border-color: #DD2A7B;
    `};

    ${(props) => props.channel === 'whatsapp' && css`
        border-color: #25D366;
    `};

    ${(props) => props.channel === 'tiktok' && css`
        border-color: #000000;
    `};

    ${(props) => props.channel === 'telegram' && css`
        border-color: #24A1DE;
    `};
`;

export const StyledCustomerOpportunitiesBadge = styled(CustomerOpportunitiesBadge)`
    padding: 0.25rem 0.5rem 0.25rem 0.375rem;
    line-height: 1;

    & svg {
        width: 1rem !important;
        height: 1rem !important;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    flex-grow: 0;
    flex-shrink: 0;

    width: 3rem !important;
    height: 3rem !important;

    svg {
        margin-right: 0 !important;
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }
`;
